import {EarnedProductData} from '../../../../shared/types';

const genChartYAxisDomain = (isPlaceholder, data?: EarnedProductData[]) => {
    if (isPlaceholder) {
        return [0, 20000];
    }

    let maxReferrals = 0;
    data.forEach(d => {
        if (d.referrals > maxReferrals) {
            maxReferrals = d.referrals;
        }
    });
    return [0, maxReferrals];
};

export default genChartYAxisDomain;
